var ODS_LOCALE;
(function (ODS_LOCALE) {
    ODS_LOCALE["AR"] = "ar";
    ODS_LOCALE["BG"] = "bg";
    ODS_LOCALE["CS"] = "cs";
    ODS_LOCALE["DA"] = "da";
    ODS_LOCALE["DE"] = "de";
    ODS_LOCALE["EL"] = "el";
    ODS_LOCALE["EN"] = "en";
    ODS_LOCALE["EO"] = "eo";
    ODS_LOCALE["ES"] = "es";
    ODS_LOCALE["ET"] = "et";
    ODS_LOCALE["EU"] = "eu";
    ODS_LOCALE["FI"] = "fi";
    ODS_LOCALE["FR"] = "fr";
    ODS_LOCALE["HR"] = "hr";
    ODS_LOCALE["HU"] = "hu";
    ODS_LOCALE["HY"] = "hy";
    ODS_LOCALE["IT"] = "it";
    ODS_LOCALE["JA"] = "ja";
    ODS_LOCALE["KO"] = "ko";
    ODS_LOCALE["LT"] = "lt";
    ODS_LOCALE["NL"] = "nl";
    ODS_LOCALE["NO"] = "no";
    ODS_LOCALE["PL"] = "pl";
    ODS_LOCALE["PT"] = "pt";
    ODS_LOCALE["RO"] = "ro";
    ODS_LOCALE["RU"] = "ru";
    ODS_LOCALE["SL"] = "sl";
    ODS_LOCALE["SV"] = "sv";
    ODS_LOCALE["TH"] = "th";
    ODS_LOCALE["UK"] = "uk";
    ODS_LOCALE["ZH"] = "zh";
})(ODS_LOCALE || (ODS_LOCALE = {}));
const ODS_LOCALES = Object.freeze(Object.values(ODS_LOCALE));
export { ODS_LOCALE, ODS_LOCALES, };
